<div class="flex flex-center">
    <app-page-title></app-page-title>&nbsp;
    <med-bubble style="margin-top: 16px">
        {{dataService.userRoleValue.getValue()}}
        <span *ngIf="'DOZ' === dataService.userRoleValue.getValue()">&nbsp;{{accountService.organizationShortName()}}</span>
    </med-bubble>
    <div style="margin-top: 16px">
    <med-select [options]="years" [(ngModel)]="year" (ngModelChange)="yearSelected($event)" [hideClearBtn]="true"></med-select>
    </div>
</div>

<app-loader *ngIf="loadingCounter > 0; else contentTemplate"></app-loader>
<ng-template #contentTemplate>
  <div class="error-container table-wrapper" *ngIf="emptyResponse">
    <app-error [errorCode]="404"></app-error>
  </div>
<div class="table-wrapper" *ngIf="!emptyResponse">
    <p-table [value]="tableBody1"
             [tableStyle]="{ 'width.%': '100' }"
             styleClass="p-datatable-sm"
             [scrollable]="true"
             scrollHeight="flex"
             [columns]="tabHeader"
             [resizableColumns]="true"
             columnResizeMode="expand"
             [reorderableColumns]="true"
             (onColReorder)="saveColumnOrder()">
        <ng-template pTemplate="header">
            <tr class="mt-2 mb-2">
              <ng-container *ngFor="let column of tabHeader">
              <th
              class="table-header-text"
              [ngClass]="{
                'table-header-big': column.size === 'big',
                'table-header-small': column.size === 'small'
              }"
              pReorderableColumn
              pResizableColumn
            >
              <div style="display: inline-block" class="flex align-items-center h9-text" [ngClass]="{'mt-2 mb-2': column.size === 'big'}">
                {{ column.label }}
              </div>

            </th>
          </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-columns="columns" *ngIf="loadingCounter === 0">
            <tr class="table-content-text">
              <ng-container *ngFor="let col of columns">
                <td class="h7-heading-14px-fontsize no-wrap black-80" *ngIf="col.key === '1'">{{getDirectionNameByDirectionId(row['directionId'])}}</td>
                <td *ngIf="col.key === '2'">
                  <p-confirmPopup>
                    <ng-template pTemplate="content" let-message>
                      <div class="flex flex-column align-items-center w-full gap-3 border-bottom-1 surface-border p-3 mb-3">
                        <i [class]="message.icon" class="text-6xl text-primary-500"></i>
                        <p>{{ message.message }}</p>
                      </div>
                    </ng-template>
                  </p-confirmPopup>
                    <med-group-control
                            *ngIf="row.organizations.length > 0"
                            [countOfVisible]="10"
                            [hasSwitchBtn]="true"
                            [showAll]="false">
                        <med-bubble
                                [styleClass]="'med-bubble-turquoise'"
                                *ngFor="let item of row.organizations; trackBy: trackByIndex"
                                group-item
                                [visibleCloseBtn]="true" (click)="deleteOrganizationFromRecipient($event, row['id'], item['id'])">
                            {{ item['fullName'] }}
                        </med-bubble>
                        <med-btn size="small" (click)="showModal(row)" skin="text" [style]="{background: '#f4f4f4', 'border-radius': '8px'}">
                            <med-icon-plus size="12"></med-icon-plus>
                        </med-btn>
                    </med-group-control>
                    <div *ngIf="row.organizations.length === 0" style="display: flex; flex-direction: row" class="flex flex-center">
                        <div class="h10-text black-30">Немає даних&nbsp;</div>
                        <div style="width: fit-content">
                            <med-btn size="small" (click)="showModal(row)" skin="gray">
                                <med-icon-plus size="12"></med-icon-plus>
                            </med-btn>
                        </div>

                    </div>

                </td>
                <td *ngIf="'MZU' === dataService.userRoleValue.getValue() && col.key === '3'">
                    <med-group-control
                            [countOfVisible]="10"
                            [hasSwitchBtn]="true"
                            [showAll]="false"
                    >
                        <med-bubble class="black-80">
                            24 області
                        </med-bubble>
                        <med-bubble class="black-80">
                            м. Київ
                        </med-bubble>
                    </med-group-control>
                </td>
                <td *ngIf="'DOZ' === dataService.userRoleValue.getValue() && col.key === '3'">
                  <med-group-control
                    *ngIf="row.experts.length > 0"
                    [countOfVisible]="10"
                    [hasSwitchBtn]="true"
                    [showAll]="false">
                    <med-bubble
                      class="med-bubble-purple"
                      [styleClass]="'med-bubble-purple'"
                      *ngFor="let item of row.experts; trackBy: trackByIndex"
                      group-item
                      [visibleCloseBtn]="true" (click)="deleteExpertsFromRecipient(row['id'], item['id'])">
                      <div class="flex-between flex gap-1" style="align-items: center">
                        <div><med-avatar class="avatar-22px" ></med-avatar></div>
                        <div style="white-space: nowrap" class="h10-text black-80">{{ item['firstName'] }}&nbsp;{{ item['lastName'] }}</div>
                      </div>
                    </med-bubble>
                    <med-btn size="small" (click)="showModalForExperts(row)" skin="text" [style]="{background: '#f4f4f4', 'border-radius': '8px'}">
                      <med-icon-plus size="12"></med-icon-plus>
                    </med-btn>
                  </med-group-control>
                  <div *ngIf="row.experts.length === 0" style="display: flex; flex-direction: row" class="flex flex-center">
                    <div class="h10-text black-30">Немає даних&nbsp;</div>
                    <div style="width: fit-content">
                      <med-btn size="small" (click)="showModalForExperts(row)" skin="gray">
                        <med-icon-plus size="12"></med-icon-plus>
                      </med-btn>
                    </div>
                  </div>
                </td>
              </ng-container>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="error-container" *ngIf="emptyResponse">
                <app-error [errorCode]="404"></app-error>
            </div>
            <div class="flex flex-center flex-between" *ngIf="!emptyResponse">
                <med-pagination
                        [total]="totalRows"
                        [page]="selectedPageNumber"
                        [perPage]="pageSize"
                        (pageChange)="pageChange($event)"
                ></med-pagination>

                <div class="small-text">
                    Показано &nbsp;<span style="color: #000000" class="h10-text">{{ getFirstShowedRowIndex() }}-{{ getFirstShowedRowIndex() + pageSize }}</span> &nbsp;з {{ totalRows }}
                </div>

                <div>
                    <span class="small-text">Кількість на сторінку</span>
                    <med-radio-group
                            mode="buttons"
                            [value]="showedOnPage"
                            [options]="paginationOptions"
                            (onInput)="pageSizeChanged($event)"
                    ></med-radio-group>
                </div>
            </div>
        </ng-template>
    </p-table>
</div>
</ng-template>


<med-modal [(visible)]="addRecipientModal" [closeableOutside]="false" [showCloseBtn]="false">
    <div [style]="{ width: '45vw', height: '65vh' }" class="flex flex-column">
        <div class="inline-flex align-items-start justify-content-start gap-2">
            <p-avatar
                    [style]="{width: '1.5em', height: '1.5em'}"
                    styleClass="mr-2"
                    image="assets/icons/big_plus.png"
                    shape="circle" />

            <span class="H6-Heading white-space-nowrap">
                    Додати отримувача
                </span>
            <div style="margin-left: auto; color: #666666; cursor: pointer" (click)="addRecipientModal = false">
                <med-icon-close></med-icon-close>
            </div>
        </div>
        <div style="display: flex; flex-direction: column; height: 100%" class="mt-4">
            <div class="mobile-h10-text" style="padding-bottom: 1em">
                Напрям
            </div>
            <div class="h10-text black-80" style="padding-bottom: 3em">
                {{directionForModal}}
            </div>
            <div class="mobile-h10-text" style="padding-bottom: 1em">
                Отримувачі
            </div>
            <div>
                <p-multiSelect
                        [overlayVisible]="false"
                        [style]="{ width: '100%', height: '8rem' }"
                        [options]="organizationsAll"
                        [(ngModel)]="selectedOrganizations"
                        [maxSelectedLabels]="7"
                        placeholder="Оберіть отримувача"
                        optionLabel="fullName"
                        display="chip"/>
            </div>
        </div>
        <div style="margin-top: auto; display: flex; flex-direction: row">
            <div style="width: 48%;">
                <med-btn skin="gray" (click)="addRecipientModal = false">Скасувати</med-btn>
            </div>
            <div style="width: 48%; margin-left: auto">
                <med-btn [disabled]="false" (click)="addOrganizationsToRecipient()">Додати</med-btn>
            </div>
        </div>

    </div>
</med-modal>

<med-modal [(visible)]="addExpertModal" [closeableOutside]="false" [showCloseBtn]="false">
  <div [style]="{ width: '45vw', height: '65vh' }" class="flex flex-column">
    <div class="inline-flex align-items-start justify-content-start gap-2">
      <p-avatar
        [style]="{width: '1.5em', height: '1.5em'}"
        styleClass="mr-2"
        image="assets/icons/big_plus.png"
        shape="circle" />

      <span class="H6-Heading white-space-nowrap">
                    Додати експерта напряму
                </span>
      <div style="margin-left: auto; color: #666666; cursor: pointer" (click)="addExpertModal = false">
        <med-icon-close></med-icon-close>
      </div>
    </div>
    <div style="display: flex; flex-direction: column; height: 100%" class="mt-4">
      <div class="mobile-h10-text" style="padding-bottom: 1em">
        Напрям
      </div>
      <div class="h10-text black-80" style="padding-bottom: 3em">
        {{directionForModal}}
      </div>
      <div class="mobile-h10-text" style="padding-bottom: 1em">
        Експерти
      </div>
      <div>
        <p-multiSelect
          [overlayVisible]="false"
          [style]="{ width: '100%', height: '8rem' }"
          [options]="expertsAll"
          [(ngModel)]="selectedExperts"
          [maxSelectedLabels]="7"
          placeholder="Оберіть експерта"
          optionLabel="lastName"
          display="chip"
          (onFocus)="disabledFlag=false"/>
      </div>
    </div>
    <div style="margin-top: auto; display: flex; flex-direction: row">
      <div style="width: 48%;">
        <med-btn skin="gray" (click)="addExpertModal = false">Скасувати</med-btn>
      </div>
      <div style="width: 48%; margin-left: auto">
        <med-btn [disabled]="disabledFlag" (click)="addExpertsToRecipient()">Додати</med-btn>
      </div>
    </div>

  </div>
</med-modal>
